<template>
    <div class="member-alarm member-tab">
        <div v-if="isAnnouncement" class="member-alarm-head">
            <div class="breadcrumb">
                <span @click="isAnnouncement = false">通知</span>
                <span>平台公告支持的版本</span>
            </div>
        </div>
        <div v-else class="member-alarm-head">
            <h1>全部通知</h1>
            <span class="setting">
                <img src="@/assets/img/icon/setting_gray.svg" alt="" srcset="">
                設定
            </span>
        </div>
        <div v-if="isAnnouncement" class="member-alarm-body">
                <h1>支持的版本</h1>
                <div class="category">
                    <div class="icon">
                        <img src="@/assets/img/component/alarm_message/announcement.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">平台公告</span>
                        <span class="time">3 小時前</span>
                    </div>
                </div>
                <div class="content">
                    桌面應用<br>
                    Zeplin的桌面應用程序可在以下操作系統上使用：<br><br>

                    蘋果電腦<br>
                    macOS 10.15卡塔利娜 <br>
                    macOS 10.14 Mojave <br>
                    macOS 10.13 High Sierra <br>
                    視窗<br>
                    Windows 7+<br>
                    網絡應用<br>
                    Zeplin的Web應用程序可在Windows，macOS和Linux設備上運行，並支持大多數現代瀏覽器以提供最佳體驗： <br>
                    鉻62+<br>
                    Firefox 59+<br>
                    Safari 11+<br>
                    優勢15+<br>
                    外掛程式<br>
                    Photoshop CC 2015以上版本<br>
                    草圖44.1+<br>
                </div>
        </div>
        <div v-else class="member-alarm-body">
            <ul>
                <li @click="isAnnouncement = true">
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/announcement.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">平台公告 公告內容文案</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <!-- <span class="unread"></span> -->
                        <img src="@/assets/img/component/alarm_message/home.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">小胖子的家 合約快到期，詢問房客是否續租</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
                <li>
                    <div class="icon">
                        <span class="unread"></span>
                        <img src="@/assets/img/component/alarm_message/user.svg" alt="">
                    </div>
                    <div class="message">
                        <span class="text">王小明 已預訂了房源 小胖子的家</span>
                        <span class="time">3 小時前</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            isAnnouncement: false
        }
    }
}
</script>
<style lang="scss" scoped>
    .member-alarm{
        position: relative;
        min-height: 554px;
        h1{
            font-size: 20px;
        }
        .member-alarm-head{
            display: flex;
            padding: 30px 30px 9px 30px;
            .setting{
                position: absolute;
                right: 30px;
                display: flex;
                align-items: center;
                color: #a8a5a4;
                >img{
                    margin-right: 2px;
                }
            }
            .breadcrumb{
                display: flex;
                list-style: none;
                padding-bottom: 15px;
                span {
                    font-size: 12px;
                    font-weight: 300;
                    cursor: pointer;
                    color: #a8a5a4;
                }
                span:last-child {
                    cursor: default;
                    color: #525956;
                }
                span:not(:last-child):after {
                    content: "/";
                    margin-left: 5px;
                    margin-right: 10px;
                }
            }
        }
        .member-alarm-body{
            margin: 0 30px;
            ul{
                li{
                    display: flex;
                    align-items: center;
                    justify-items: center;
                    border-bottom: 1px solid #f1f5f4;
                    padding: 16px 0;
                    cursor: pointer;
                    .icon{
                        position: relative;
                        display: flex;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        margin-right: 12px;
                        border-radius: 20px;
                        background-color: #f6f6f6;
                        .unread{
                            position: absolute;
                            width: 8px;
                            height: 8px;
                            background-color: #ffd249;
                            border-radius: 4px;
                            top: 2px;
                            right: 2px;
                        }
                        >img{
                            margin: 0 auto;
                        }
                    }
                    .message{
                        display: flex;
                        flex-direction: column;
                        .text{
                            margin-bottom: 4px;
                        }
                        .time{
                            color: #a8a5a4;
                        }
                    }
                }
            }
            .category{
                display: flex;
                align-items: center;
                justify-items: center;
                margin-top: 5px;
                padding: 20px 0;
                cursor: pointer;
                .icon{
                    position: relative;
                    display: flex;
                    align-items: center;
                    width: 40px;
                    height: 40px;
                    margin-right: 12px;
                    border-radius: 20px;
                    background-color: #f6f6f6;
                    >img{
                        margin: 0 auto;
                    }
                }
                .message{
                    display: flex;
                    flex-direction: column;
                    .text{
                        margin-bottom: 4px;
                    }
                    .time{
                        color: #a8a5a4;
                    }
                }
            }
            .content{
                width: 660px;
                font-weight: 300;
                line-height: 1.71;
                color: #181817;
                padding-bottom: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/MemberAlarm.vue